var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel__opened" }, [
    _c(
      "div",
      { on: { mousemove: _vm.setCurrentHovered } },
      [
        _c(
          "ul",
          {
            staticClass:
              "outlookSearchResults scrollBox pos-static outlookSearchResults--small",
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("li", [
              !_vm.matchesCurrentOutlook.length > 0
                ? _c(
                    "span",
                    {
                      staticClass: "marketingHubPageAutoComplete--resultsItem",
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "margin-horizontal-20 margin-bottom-30",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.trans(
                                  "XMO_HIGHLIGHTS_SEARCH_NO_RESULTS_CURRENT_MARKET"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.matchedSearchResults.length && _vm.matchesCurrentOutlook.length
              ? _vm._l(_vm.matchesCurrentOutlook, function (match, index) {
                  return _c(
                    "li",
                    {
                      key: `${match.product}--${index}`,
                      ref: "results",
                      refInFor: true,
                      staticClass:
                        "marketingHubPageAutoComplete--resultsItem outlookMarketingHub__icons flex flex-center quickStart__item",
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          )
                            return null
                          return _vm.changeProduct(match)
                        },
                        mousemove: function ($event) {
                          return _vm.setTabActive(
                            match,
                            _vm.$refs.results,
                            $event
                          )
                        },
                      },
                    },
                    [
                      _c("MatchResult", {
                        attrs: {
                          match: match,
                          "match-market-link": _vm.generateMarketLink(
                            match.url,
                            match.slug
                          ),
                          gtm: `xmoHighlights__matchedResult--${_vm.sanitizeDataGtm(
                            match.market
                          )}`,
                          "selected-product": _vm.selectedProduct,
                          "icon-class": _vm.generateIconClass(match),
                          "market-name": _vm.generateMarketName(match.product),
                          "svg-icon": _vm.getSvgIcon(match.product),
                        },
                      }),
                      _vm._v(" "),
                      _c("MatchOverview", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.selectedProduct.uid === match.uid,
                            expression: "selectedProduct.uid === match.uid",
                          },
                        ],
                        attrs: {
                          "market-name": _vm.generateMarketName(
                            _vm.selectedProduct.product
                          ),
                          market: _vm.selectedProduct.market,
                          description: _vm.formatDescription(
                            _vm.selectedProduct.description
                          ),
                          "market-link": _vm.generateMarketLink(
                            _vm.selectedProduct.url,
                            _vm.selectedProduct.slug
                          ),
                          gtm: `xmoHighlights__matchedResultOverview--${_vm.sanitizeDataGtm(
                            match.market
                          )}`,
                        },
                      }),
                    ],
                    1
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.matchedSearchResults.length && _vm.matchesOtherOutlooks.length
              ? [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.matchesOtherOutlooks, function (match, index) {
                    return _c(
                      "li",
                      {
                        key: `${match.product}--${index}`,
                        ref: "results",
                        refInFor: true,
                        staticClass:
                          "marketingHubPageAutoComplete--resultsItem outlookMarketingHub__icons flex flex-center quickStart__item",
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "tab",
                                9,
                                $event.key,
                                "Tab"
                              )
                            )
                              return null
                            return _vm.changeProduct(match)
                          },
                          mousemove: function ($event) {
                            return _vm.setTabActive(
                              match,
                              _vm.$refs.results,
                              $event
                            )
                          },
                        },
                      },
                      [
                        _c("MatchResult", {
                          attrs: {
                            match: match,
                            "match-market-link": _vm.generateMarketLink(
                              match.url,
                              match.slug
                            ),
                            gtm: `xmoHighlights__matchedResult--${_vm.sanitizeDataGtm(
                              match.market
                            )}`,
                            "icon-class": _vm.generateIconClass(match),
                            "market-name": _vm.generateMarketName(
                              match.product
                            ),
                            "svg-icon": _vm.getSvgIcon(match.product),
                          },
                        }),
                        _vm._v(" "),
                        _c("MatchOverview", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.selectedProduct.uid === match.uid,
                              expression: "selectedProduct.uid === match.uid",
                            },
                          ],
                          attrs: {
                            "market-name": _vm.generateMarketName(
                              _vm.selectedProduct.product
                            ),
                            market: _vm.selectedProduct.market,
                            description: _vm.formatDescription(
                              _vm.selectedProduct.description
                            ),
                            "market-link": _vm.generateMarketLink(
                              _vm.selectedProduct.url,
                              _vm.selectedProduct.slug
                            ),
                            gtm: `xmoHighlights__matchedResultOverview--${_vm.sanitizeDataGtm(
                              match.market
                            )}`,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.showAiResults
          ? _c("div", {
              attrs: {
                "data-fb-container": "xmoAiSearchResults__feedback",
                "data-fb-request": _vm.searchInput,
                "data-fb-response": JSON.stringify(_vm.aiSearchResults),
              },
            })
          : _vm._e(),
        _vm._v(" "),
        [
          _vm.showAiResults
            ? _c("div", { staticClass: "xmoAiLoadingBannerFooter" }, [
                _c("p", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.trans("XMO_POWERED_BY")) +
                      "\n                    "
                  ),
                  _c(
                    "span",
                    { staticClass: "xmoAiLoadingBannerFooter__aiText" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.trans("OPEN_AI")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        _vm._v(" "),
        _vm._m(2),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "h2",
        {
          staticClass:
            "marketingHubPage--quickStart__header text-color--dark-blue-gray",
        },
        [
          _vm._v(
            "\n                    " +
              _vm._s(_vm.generateMarketName(_vm.currentOutlook)) +
              " " +
              _vm._s(
                _vm.trans("XMO_HIGHLIGHTS_SEARCH_RESULTS_TOPIC_HEADLINE")
              ) +
              "\n                "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("span", [
        _c(
          "h2",
          {
            staticClass:
              "marketingHubPage--quickStart__header text-color--dark-blue-gray margin-horizontal-20 margin-bottom-30",
          },
          [
            _vm._v(
              "\n                            " +
                _vm._s(
                  _vm.trans("XMO_HIGHLIGHTS_SEARCH_RESULTS_OTHER_MARKET")
                ) +
                "\n                        "
            ),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "highlights--footer linkArrowHover" }, [
      _vm._v(
        "\n            " +
          _vm._s(_vm.trans("XMO_HIGHLIGHTS_UNDERSTAND_MARKETS")) +
          "\n            "
      ),
      _c(
        "a",
        {
          attrs: {
            href: _vm.getPath("outlookHubPage"),
            role: "menuitem",
            "data-gtm": "xmoHighlights__mainMarketsLink",
          },
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.trans("XMO_HIGHLIGHTS_VISIT_MARKET")) +
              "\n                "
          ),
          _c(
            "svg",
            {
              staticClass: "stat__svgIcon margin-left-5",
              attrs: { "aria-hidden": "true" },
            },
            [_c("use", { attrs: { href: "#iconArrowRightLongBold" } })]
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }